import clsx from 'clsx';

interface SkeletonProps {
  className?: string;
}

export function SkeletonText({ className }: SkeletonProps) {
  return <div className={clsx('skeleton h-4 w-full', className)} />;
}

export function SkeletonCard({ className }: SkeletonProps) {
  return (
    <div className={clsx('glass-card p-6 space-y-4', className)}>
      <div className="flex items-center justify-between">
        <div className="skeleton h-5 w-24" />
        <div className="skeleton h-10 w-10 rounded-lg" />
      </div>
      <div className="skeleton h-8 w-20" />
      <div className="skeleton h-3 w-32" />
    </div>
  );
}

export function SkeletonRow({ className }: SkeletonProps) {
  return (
    <div className={clsx('flex items-center gap-4 p-4', className)}>
      <div className="skeleton h-10 w-10 rounded-lg flex-shrink-0" />
      <div className="flex-1 space-y-2">
        <div className="skeleton h-4 w-3/4" />
        <div className="skeleton h-3 w-1/2" />
      </div>
      <div className="skeleton h-6 w-16 rounded-full" />
    </div>
  );
}

export function SkeletonChart({ className }: SkeletonProps) {
  return (
    <div className={clsx('glass-card p-6', className)}>
      <div className="skeleton h-5 w-40 mb-6" />
      <div className="flex items-end gap-2 h-48">
        {Array.from({ length: 12 }).map((_, i) => (
          <div
            key={i}
            className="skeleton flex-1 rounded-t"
            style={{ height: `${20 + Math.random() * 80}%` }}
          />
        ))}
      </div>
    </div>
  );
}

export function SkeletonSensorCard({ className }: SkeletonProps) {
  return (
    <div className={clsx('glass-card p-4 space-y-4', className)}>
      <div className="flex items-start justify-between">
        <div className="flex items-center gap-3">
          <div className="skeleton h-10 w-10 rounded-lg" />
          <div className="space-y-2">
            <div className="skeleton h-5 w-28" />
            <div className="skeleton h-3 w-16" />
          </div>
        </div>
        <div className="skeleton h-6 w-16 rounded-full" />
      </div>
      <div className="space-y-2">
        <div className="skeleton h-3 w-full" />
        <div className="skeleton h-3 w-2/3" />
      </div>
      <div className="flex gap-2 pt-3 border-t border-navy-700">
        <div className="skeleton h-8 flex-1 rounded" />
        <div className="skeleton h-8 flex-1 rounded" />
      </div>
    </div>
  );
}
